import loadable from "@loadable/component";
import CustomerIcon from "../../Icons/CustomerIcon";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
import { tw } from "@careinfo/tailwind";

const CustomerListComponent = loadable(
  () => import("../../components/Customer/CustomerList")
);

const CustomerList = () => {
  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ["customer"],
  });
  const handleSetIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.CUSTOMER}${id}/`;
    const formData = payload;
    try {
      await mutateAsync({ url, formData });
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <>
      <div className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}>
        <CustomerIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Customer</span>
      </div>
      <CustomerListComponent handleSetIsActive={handleSetIsActive} />
    </>
  );
};

export default CustomerList;
